module.exports = __webpack_public_path__ + "img/Checkbox-inactive.16ba2d86b.svg";